import { useSelector } from 'react-redux'
import { hasActiveProject } from 'src/redux/slices/project/selectors'

import Box from '@material-ui/core/Box'

import NoProjectWidget from '../components/NoProjectWidget'
import Survey from '../components/Survey'

const SurveyPage: React.FC = () => {
  const active = useSelector(hasActiveProject)
  return active ? (
    <Box style={{ marginBottom: '5rem' }}>
      <Survey />
    </Box>
  ) : (
    <NoProjectWidget />
  )
}
export default SurveyPage
